'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = require('../../constants/events/video');

var _video2 = _interopRequireDefault(_video);

var _loader = require('./loader.view');

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DELAY_FOR_SHOW_ON_WAITING_STATE = 100;

var Loader = function () {
  function Loader(_ref) {
    var config = _ref.config,
        eventEmitter = _ref.eventEmitter,
        engine = _ref.engine;

    _classCallCheck(this, Loader);

    this._eventEmitter = eventEmitter;
    this.isHidden = false;
    this._engine = engine;
    this.config = _extends({}, config);

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this._initUI();
    this._bindEvents();
  }

  _createClass(Loader, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._checkForWaitingState, this);
      this._eventEmitter.on(_video2.default.UPLOAD_SUSPEND, this.hide, this);
    }
  }, {
    key: '_checkForWaitingState',
    value: function _checkForWaitingState(_ref2) {
      var nextState = _ref2.nextState;
      var STATES = this._engine.STATES;

      switch (nextState) {
        case STATES.SEEK_STARTED:
          this._startDelayedShow();
          break;
        case STATES.SEEK_ENDED:
          this._stopDelayedShow();
          this.hide();
          break;
        case STATES.WAITING:
          this._startDelayedShow();
          break;
        case STATES.LOAD_STARTED:
          this.show();
          break;
        case STATES.READY_TO_PLAY:
          this._stopDelayedShow();
          this.hide();
          break;
        case STATES.PLAYING:
          this._stopDelayedShow();
          this.hide();
          break;

        default:
          break;
      }
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var view = this.config.view;


      if (view) {
        this.view = new view();
      } else {
        this.view = new this.constructor.View();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.isHidden) {
        this.view.hide();
        this.isHidden = true;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.isHidden) {
        this.view.show();
        this.isHidden = false;
      }
    }
  }, {
    key: '_startDelayedShow',
    value: function _startDelayedShow() {
      this._stopDelayedShow();
      this._delayedShowTimeout = setTimeout(this.show, DELAY_FOR_SHOW_ON_WAITING_STATE);
    }
  }, {
    key: '_stopDelayedShow',
    value: function _stopDelayedShow() {
      clearTimeout(this._delayedShowTimeout);
      this._delayedShowTimeout = null;
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._checkForWaitingState, this);
      this._eventEmitter.off(_video2.default.UPLOAD_SUSPEND, this.hide, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this._stopDelayedShow();

      this.view.destroy();

      delete this.view;

      delete this._eventEmitter;
      delete this._engine;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return Loader;
}();

Loader.View = _loader2.default;
exports.default = Loader;
//# sourceMappingURL=loader.controler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/loader/loader.controler.js
// module id = 1231
// module chunks = 1 2 3